import React, { Component, PropTypes } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import EntryGallery from 'common/components/entry_gallery';
import { getDefaultGrouping } from 'common/components/entry_gallery/grouping_selector';
import Pager from 'common/pager/containers';
import SorterSelect from 'common/sorter/components/select';
import Filter from 'common/filter/containers';
import GroupingSelector from 'common/components/entry_gallery/grouping_selector';
import { TYPE_CHECKBOXES } from 'common/filter/constants';
import { getSortingOptions, SCORE_OPTIONS, NEW_OPTIONS } from 'entries/constants';
import { hasAPIQueryStringChanged } from 'common/utils';

export default class Entries extends Component {
  componentDidMount() {
    const { fetch, setGrouping } = this.props;
    setGrouping(getDefaultGrouping());
    fetch();
  }

  componentDidUpdate(prevProps) {
    const { resourceName, fetch } = this.props;

    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(resourceName, prevProps, this.props)) {
      fetch();
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  render() {
    const {
      entries, grouped, isFetching, project, resourceName, onItemClick, setGrouping, itemVariation
    } = this.props;
    const sortingOptions = getSortingOptions(project.entry_type, true);

    return (
      <div className="row">
        { isFetching?
        <div className="columns small-16 large-12">
          <LoadingIndicator />
        </div> :
        <div className="columns small-16 large-12">
          <EntryGallery entryType={project.entry_type} viewType='grid' onItemClick={onItemClick}
            itemVariation={itemVariation} items={entries} grouped={grouped} />
          <Pager resourceName={resourceName} />
        </div> }
        <div className="columns small-16 large-4">
          <div className="project-gallery-controls sidebar sidebar-filter">
            <GroupingSelector entryType={project.entry_type} grouped={grouped}
              onChange={setGrouping} />
            <div className="controls-group">
              <h5 className="sorting-name">Sort</h5>
              <SorterSelect resourceName={resourceName} options={sortingOptions}
                defaultValue="-created_at" />
            </div>
            <div className="controls-group">
              <h5 className="sorting-name">Filters</h5>
              <Filter field="score" type={TYPE_CHECKBOXES} resourceName={resourceName}
                options={SCORE_OPTIONS} />
              <Filter field="new" type={TYPE_CHECKBOXES} resourceName={resourceName}
                options={NEW_OPTIONS} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Entries.propTypes = {
  resourceName: PropTypes.string.isRequired,
  itemVariation: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  entries: PropTypes.array.isRequired,
  grouped: PropTypes.bool,
  fetch: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/entries.jsx